<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1 data-test="pageTitle">Manage Service Lines</h1>    
        	<div class="card">
                <table class="table table-hover">
                	<thead>
                		<th>ID</th>
                		<th>Label</th>
                		<th>Actions</th>
                	</thead>
                	<tr v-for="serviceLine in serviceLines">
                		<td>
                			<label>{{ serviceLine.id }}</label>
                		</td>
                		<td>
                			<template v-if="serviceLine.id === editing.id">				
                				<input class="form-control" v-model="editing.label">
                			</template>
                			<template v-else>
                				{{ serviceLine.label }}
                			</template>
                		</td>
                		<td>
                			<template v-if="serviceLine.id === editing.id">
                				<button class="btn btn-primary" @click="updateServiceLine(serviceLine.id)">Save</button>
                				<button class="btn btn-outline-secondary" @click="resetEditing(serviceLine.id)">Cancel</button>
                				<button class="btn btn-outline-warning" @click="deleteServiceLine(serviceLine.id)">Delete</button>
                			</template>

                			<template v-else>
                				<button class="btn btn-outline-primary" @click="setEditing(serviceLine.id)">edit</button>
                			</template>
                						
                		</td>
                	</tr>
                </table>
                <div class="card-body">
                	<div class="form-inline">
                			<label class="mr-3">Add new service line:</label>
                			<input class="form-control mr-2" v-model="newServiceLine.label" placeholder="Service line name">
                			<button class="btn btn-primary" @click="addServiceLine()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
        mixins: [BreadcrumbsManager],

        data() {
            return {
                serviceLines: [],

                newServiceLine: {
                	label: '',
                },

                editing: {
                	id: '',
                	label: '',
                },

                oldLabel: '',
            }
        },

        created() {
        	this.fetchServiceLines();
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Settings', to: { name: '' } },
                { text: 'Service Lines', to: { name: 'admin.service.lines' } },
            ]);  
        },

        methods: {
        	fetchServiceLines() {
                axios.get(`/api/service-lines`).then(({data}) => {
                    this.serviceLines = data;
                })
        	},

        	addServiceLine() {
        		axios.post('/api/service-lines', this.newServiceLine).then(({data}) => {
                    this.serviceLines.push(data);
                })
        	},

        	setEditing(id) {
        		this.editing.id = id;
        		this.editing.label = this.serviceLines.find(x => x.id === id).label;
        		this.oldLabel = this.serviceLines.find(x => x.id === id).label;
        	},

        	resetEditing(id) {
        		this.editing.id = '';
        		this.serviceLines.find(x => x.id === id).label = this.oldLabel;
        	},

            updateServiceLine(id) {
                axios.put(`/api/service-lines/${id}`, this.editing).then(({data}) => {
                    this.serviceLines.find(x => x.id === id).label = data.label;
                    this.setEditing(0);
                })
            },

            deleteServiceLine(id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this service line!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete service line',
                    cancelButtonText: 'Keep service line',
                    animation: false,
                }).then((result) => {
                    if (result.value) {
                        axios.delete(`/api/service-lines/${id}`, id).then(() => {
                        	let index = this.serviceLines.map(function (lines) { return lines.id; }).indexOf(id);
                        	this.serviceLines.splice(index, 1);
                        })
                    }
                });
            },
        },
    }
</script>